import addCustomField from './addCustomFieldSaga'
import editCustomField from './editCustomFieldSaga'
import deleteCustomField from './deleteCustomFieldSaga'

const addCustomFieldSaga = [addCustomField(), editCustomField(), deleteCustomField()]

export default addCustomFieldSaga
